export default () => ({
  entities: 'agendas',
  agendas: [],
  ishidden: false
})



// WEBPACK FOOTER //
// ./src/app/team/dashboard/gadget/components/agendas-statistics/resources/data.js